<template>
  <div class="vendor-detail">
    <img
      src="@/assets/images/vendor_detail_bg.png"
      alt=""
      class="bg img-fluid"
    />
    <div class="content container px-2 px-md-0">
      <div class="info mb-4 mb-md-5">
        <img
          :src="`${baseUrl}/uploadFile/pictureView.htm?id=${supplier.logoId}`"
          class="logo"
          alt=""
        />
        <div class="right">
          <div class="top">
            <h2 class="mb-2 mr-1 mt-2 mb-md-0 mr-md-0 mt-md-0 title">
              {{ supplier.companyName }}
            </h2>
            <Stars :score="supplier.star"></Stars>
          </div>
          <p class="slogan mb-1 mb-md-0">{{ supplier.companyIntroduce }}</p>
          <div class="bottom mb-1 mb-md-0">
            <span class="area">擅长领域: {{ supplier.goodField }}</span>
            <span class="city"
              >所在城市: {{ supplier.city && supplier.city.name }}</span
            >
          </div>
        </div>
        <button class="contact-button" @click="showModal">联系沟通</button>
      </div>
      <div class="experience-list">
        <h2 class="title mb-3 mb-md-4">
          项目经验<span>/Project experience</span>
        </h2>
        <div class="experience-item">
          <h3 class="name">{{ supplier.experienceName }}</h3>
          <p class="middle">
            <span>{{ supplier.experienceTime }}</span>
          </p>
          <p class="detail">{{ supplier.experienceIntroduce }}</p>
        </div>
      </div>
    </div>
    <vendor-contact-modal
      ref="contactModal"
      :name="supplier.contactName"
      :phone="supplier.contactPhone"
      :email="supplier.contactEmail"
    ></vendor-contact-modal>
  </div>
</template>
<style lang="scss" scoped>
.vendor-detail {
  padding-bottom: 5.6rem;
  .bg {
    margin-bottom: 2.5rem;
  }
  text-align: left;
  .content {
    .info {
      display: flex;
      flex-wrap: wrap;
      position: relative;
      .logo {
        width: 8.75rem;
        height: 8.75rem;
        margin-right: 1.5rem;
        object-fit: cover;
        flex-shrink: 0;
      }
      .right {
        flex-grow: 1;
        flex-basis: 80%;
        color: #666666;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .top {
          display: flex;
          align-items: center;
          h2 {
            font-size: 1.75rem;
            color: #333333;
          }
        }
        .slogan {
          font-size: 1.25rem;
        }
        .bottom {
          font-size: 1.25rem;
          .area {
            white-space: nowrap;
            margin-right: 8rem;
          }
          .city {
            white-space: nowrap;
          }
        }
      }

      .contact-button {
        position: absolute;
        top: 0;
        right: 0;
        width: 9.38rem;
        height: 2.38rem;
        font-size: 1.25rem;
        color: white;
        background-color: $acentColor;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        border: none;
      }
    }
    .experience-list {
      text-align: left;
      .title {
        font-size: 1.75rem;
        color: #333333;
        text-align: left;
        span {
          font-size: 1.5rem;
          color: #999999;
        }
      }
      .experience-item {
        border-bottom: solid 0.06rem #e5e5e5;
        .name {
          font-size: 1.5rem;
          color: $acentColor;
        }
        .middle span {
          font-size: 1.25rem;
          color: #333333;
          margin-bottom: 1.31rem;
        }
        .detail {
          font-size: 1.25rem;
          color: #666666;
          margin-bottom: 2rem;
        }
      }
    }
  }
}
</style>
<script>
import Stars from '@/components/Stars';
import VendorContactModal from '@/components/VendorContactModal';
import ApiService from '@/common/api.service';
import { mapMutations } from 'vuex';
import qs from 'qs';
export default {
  data() {
    return {
      contact: {
        name: '张三',
        phone: '18562354893',
        email: '18562354893@163.com'
      },
      vendor: {
        name: '博彦新光科技',
        slogan: '我们拥有自己的团队，可以对您的需求进行个性化开发',
        area: '前端、后端、iOS、Android',
        city: '广东省广州市天河区',
        score: 4
      },
      experienceList: Array(3).fill({
        name: '淘帮主',
        product: 'APP',
        time: '2015.01-2016.01',
        job: '开发工程师',
        detail:
          '澳洲跨境电商，通过视频直播的方式做电商。澳洲跨境电商，通过视频直播的方式做电商。澳洲跨境电商，通过视频直播的方式做电商。澳洲跨境电商，通过视频直播的方式做电商。'
      }),
      supplier: {}
    };
  },
  created() {
    this.setAuth(false);
    let data = {
      token: this.token,
      id: this.$route.query.id
    };
    ApiService.post(
      '/supplierInterface/getSupplierByID.htm',
      qs.stringify(data)
    ).then(({ supplier }) => {
      console.log(supplier);
      this.supplier = supplier;

      // this.contact.name = data.contactName;
      // this.contact.phone = data.contactPhone;
      // this.contact.email = data.contactEmail;
    });
    console.log(this.$route.query.id);
  },
  components: {
    Stars,
    VendorContactModal
  },
  methods: {
    showModal() {
      this.$refs.contactModal.show();
    },
    hideModal() {
      this.$refs.contactModal.hide();
    },
    ...mapMutations(['setAuth'])
  }
};
</script>
